export const eList = [
  {
    title: '您能看到事物有趣的一面，并笑得开心。',
    label: 'E01',
    questioList: [
      { label: '同以前一样', num: 0 },
      { label: '没有以前那么多', num: 1 },
      { label: '肯定比以前少', num: 2 },
      { label: '完全不能', num: 3 }
    ]
  },
  {
    title: '您欣然期待未来的一切。',
    label: 'E02',
    questioList: [
      { label: '同以前一样', num: 0 },
      { label: '没有以前那么多', num: 1 },
      { label: '肯定比以前少', num: 2 },
      { label: '完全不能', num: 3 }
    ]
  },
  {
    title: '当事情出错时，您会不必要地责备自己。',
    label: 'E03',
    questioList: [
      { label: '同以前一样', num: 0 },
      { label: '没有以前那么多', num: 1 },
      { label: '肯定比以前少', num: 2 },
      { label: '完全不能', num: 3 }
    ]
  },
  {
    title: '您无缘无故感到焦虑和担心。',
    label: 'E04',
    questioList: [
      { label: '一点也没有', num: 0 },
      { label: '极少有', num: 1 },
      { label: '有时候这样', num: 2 },
      { label: '经常这样', num: 3 }
    ]
  },
  {
    title: '您无缘无故感到害怕和惊慌。',
    label: 'E05',
    questioList: [
      { label: '一点也没有', num: 0 },
      { label: '不经常这样', num: 1 },
      { label: '有时候这样', num: 2 },
      { label: '相当多时候这样', num: 3 }
    ]
  },
  {
    title: '很多事情冲着您而来，使您透不过气。',
    label: 'E06',
    questioList: [
      { label: '您一直都能应付得好', num: 0 },
      { label: '大部分时候您都能像平时那样应付得好', num: 1 },
      { label: '有时候您不能像平时那样应付得好', num: 2 },
      { label: '大多数时候您都不能应付', num: 3 }
    ]
  },
  {
    title: '您很不开心,以致失眠。',
    label: 'E07',
    questioList: [
      { label: '没有这样', num: 0 },
      { label: '不经常这样', num: 1 },
      { label: '有时候这样', num: 2 },
      { label: '大部分时候这样', num: 3 }
    ]
  },
  {
    title: '您感到难过和悲伤。',
    label: 'E08',
    questioList: [
      { label: '没有这样', num: 0 },
      { label: '不经常这样', num: 1 },
      { label: '有时候这样', num: 2 },
      { label: '大部分时候这样', num: 3 }
    ]
  },
  {
    title: '您不开心到哭泣。',
    label: 'E09',
    questioList: [
      { label: '没有这样', num: 0 },
      { label: '不经常这样', num: 1 },
      { label: '有时候这样', num: 2 },
      { label: '大部分时候这样', num: 3 }
    ]
  },
  {
    title: '您想过要伤害自己。',
    label: 'E10',
    questioList: [
      { label: '没有这样', num: 0 },
      { label: '很少这样', num: 1 },
      { label: '有时候这样', num: 2 },
      { label: '相当多时候这样', num: 3 }
    ]
  }
]
const dDuestionList = [
  { label: '没有', num: 0 },
  { label: '有几天', num: 1 },
  { label: '一半时间以上', num: 2 },
  { label: '几乎天天', num: 3 }
]
export const dList = [
  {
    title: '最近两周以来，你是否几乎在每天的大部分时间感到心情压抑或情绪低落？',
    label: 'D1',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，对于平日你所喜欢的事情，你是否失去了兴趣或愉快感?',
    label: 'D2',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你入睡困难、睡不踏实或睡得过多？',
    label: 'D3',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你感觉疲倦或没有活力？',
    label: 'D4',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你食欲不振或吃得太多？',
    label: 'D5',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你觉得自己很糟或觉得自己很失败，或让自己、家人失望？',
    label: 'D6',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你是否对事物专注有困难，例如看报纸或看电视时',
    label: 'D7',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你行动或说话速度缓慢到别人已经觉察？或刚好相反，变得比平日更烦躁或坐立不安，动来动去？',
    label: 'D8',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你是否有不如死掉或用某种方式伤害自己的念头？',
    label: 'D9',
    questioList: dDuestionList
  }
]
export const gList = [
  {
    title: '最近两周以来，你是否感觉紧张，焦虑或急切？',
    label: 'G1',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你是否感觉不能停止或控制担忧',
    label: 'G2',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你是否感觉对各种各样的事情担忧过多',
    label: 'G3',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你是否感觉很难放松下来',
    label: 'G4',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你是否感觉由于不安而无法静坐',
    label: 'G5',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你是否感觉变得容易烦恼或急躁',
    label: 'G6',
    questioList: dDuestionList
  },
  {
    title: '最近两周以来，你是否感觉感到害怕，似乎将有可怕的事情发生',
    label: 'G7',
    questioList: dDuestionList
  }
]
export const mList = [
  {
    title: '首先，跟平常的状态比起来，您今天的感觉如何？',
    label: 'M1',
    questioList: [
      { label: '比平常差多了', num: 0 },
      { label: '比平常差', num: 1 },
      { label: '比平常差一点', num: 2 },
      { label: '比平常差不多好', num: 3 },
      { label: '比平常好', num: 4 },
      { label: '比平常好一点', num: 5 },
      { label: '比平常好很多', num: 6 }
    ]
  },
  {
    title: '整个孕产期，你是否曾有一段时间，感觉“情绪高昂”或者感觉精力充沛，或者遇到麻烦时仍充满自信，或者其他人认为你和平时不一样？',
    label: 'M2',
    questioList: [
      { label: '没有', num: 0 },
      { label: '有几天', num: 1 },
      { label: '一半时间以上', num: 2 },
      { label: '几乎天天', num: 3 }
    ]
  },
  {
    title: '近一个月来，通常每晚实际睡眠约几个小时？（指实际睡着到醒来的时间，不等于卧床时间）',
    label: 'M3',
    questioList: [
      { label: '<5小时', num: 0 },
      { label: '5-6小时', num: 1 },
      { label: '6-7小时', num: 2 },
      { label: '>7小时', num: 3 }
    ]
  },
  {
    title: '近一个月来，你认为自己的睡眠',
    label: 'M4',
    questioList: [
      { label: '很好', num: 0 },
      { label: '一般', num: 1 },
      { label: '较差', num: 2 },
      { label: '很差', num: 3 }
    ]
  },
  {
    title: '近一个月内，你是否被一些重复出现的想法、冲动或影像所困扰，而且这些是你不想要的、令人不快的、不适宜的、突然冒出来的或者令人痛苦的？',
    label: 'M5',
    questioList: [
      { label: '没有', num: 0 },
      { label: '有几天', num: 1 },
      { label: '一半时间以上', num: 2 },
      { label: '几乎天天', num: 3 }
    ]
  },
  {
    title: '近一个月内，你是否会无法抗拒地反复做某种事情，如过度洗涤或清洗，没完没了地检查或计数，或重复、整理、摆放物品？',
    label: 'M6',
    questioList: [
      { label: '没有', num: 0 },
      { label: '有几天', num: 1 },
      { label: '一半时间以上', num: 2 },
      { label: '几乎天天', num: 3 }
    ]
  }
]

export default {
  // eList
}
